import { api } from '@/lib/api'
import type { ReportDef, ReportResultTable } from '@/components/ReportRunner'

const yearNow = () => String(new Date().getFullYear())
const single = (obj: Record<string, unknown> | null | undefined): Record<string, unknown>[] => (obj ? [obj] : [])

export const TAX_REPORTS: ReportDef[] = [
  {
    slug: 'filings_register',
    name: 'Filings Register',
    description: 'Every tax filing in a year by type, jurisdiction, and status.',
    params: [{ key: 'tax_year', label: 'Tax year', type: 'number', required: true, defaultValue: yearNow() }],
    async run(p) {
      const r = await api.get<{ data: Record<string, unknown>[] }>(`/api/tax/filings?tax_year=${encodeURIComponent(p.tax_year)}`)
      return [{ rows: r.data ?? [] }]
    },
  },
  {
    slug: 'payment_register',
    name: 'Payment Register',
    description: 'Every tax payment with scheduled / released / settled status and confirmation numbers.',
    async run() {
      const r = await api.get<{ data: Record<string, unknown>[] }>('/api/tax/payments')
      return [{ rows: r.data ?? [] }]
    },
  },
  {
    slug: 'reconciliation_summary',
    name: 'Reconciliation Summary',
    description: '941 quarterly sums vs W-2, ledger vs filings, and payments vs acknowledgments.',
    async run() {
      const r = await api.get<{ data: Record<string, unknown>[] }>('/api/tax/reconciliations')
      return [{ rows: r.data ?? [] }]
    },
  },
  {
    slug: 'nexus_report',
    name: 'Nexus Report',
    description: 'Per-state rolling revenue, transaction count, and economic-nexus threshold status.',
    async run() {
      const r = await api.get<{ data: Record<string, unknown>[] }>('/api/tax/nexus')
      return [{ rows: r.data ?? [] }]
    },
  },
  {
    slug: 'audit_pack',
    name: 'Audit Pack',
    description: 'All filings, payments, and reconciliations for a tax year bundled for audit.',
    params: [{ key: 'tax_year', label: 'Tax year', type: 'number', required: true, defaultValue: yearNow() }],
    async run(p) {
      const r = await api.get<{ data: { summary?: Record<string, unknown>; filings?: Record<string, unknown>[]; payments?: Record<string, unknown>[]; reconciliations?: Record<string, unknown>[] } }>(`/api/tax/reports/audit-pack?tax_year=${encodeURIComponent(p.tax_year)}`)
      const d = r.data || {}
      const tables: ReportResultTable[] = [{ title: 'Summary', rows: single(d.summary) }]
      tables.push({ title: 'Filings', rows: d.filings ?? [] })
      tables.push({ title: 'Payments', rows: d.payments ?? [] })
      tables.push({ title: 'Reconciliations', rows: d.reconciliations ?? [] })
      return tables
    },
  },
]
